import {
    sendPostRequest,
    sendPatchRequest,
    sendDeleteRequest,
    sendGetRequest,
    sendPutRequest,
    sendPostFileRequest, sendPutFileRequest
} from "@/helper/requests";
import representative from "@/urls/roles/representative";
import {executeRequest} from "@/store/utils";

const state = {
    orders:{
        currentUrl: null,
        items: [],
        loading: false,
        not_formed_orders: false,
        count: 0,
        error: null,
        detail: [],
        limits: [],
        organization: null
    }
}

const getters = {
    getOrdersList: state => state.orders.items,
    getOrdersCount: state => state.orders.count,
    getOrdersCurrentUrl: state => state.orders.currentUrl,
    isLoadingOrders: state => state.orders.loading,
    isNotFormedOrders: state => state.orders.not_formed_orders,
    getOrdersDetail: state => state.orders.detail,
    saveOrdersError: state => state.orders.error,
    getOrdersLimits: state => state.orders.limits
}

const actions = {
    loadOrdersList: ({commit, getters}, {url, urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {
        if (!url) {
            url = representative.REPRESENTATIVE.ORDERS.LIST()
            if (urlAppend) url = urlAppend(url)
        }
        if (!getters.isLoadingOrders){
            commit("SET_ORDERS_LOADING");
            sendGetRequest(
                url, (data, url) => {
                    commit("SET_ORDERS_LIST", data["results"]);
                    commit("SET_ORDERS_COUNT", data["count"]);
                    commit("SET_NOT_FORMED_ORDERS", data["not_formed_orders"]);
                    commit("SET_ORDERS_CURRENT_URL", url);
                    commit("SET_ORDERS_LOADING_END");
                    finalizer(data, url);
                }, (data, url) => {
                    commit("SET_ORDERS_LOADING_END");
                    commit("SAVE_ORDERS_ERROR", data);
                    catcher(data, url);
                }
            )
        }
    },
    loadOrdersDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
        if (!url) url = representative.REPRESENTATIVE.ORDERS.DETAIL(id)
        sendGetRequest(
            url, (data, url) => {
                commit("SET_ORDERS_DETAIL", data);
                finalizer(data, url);
            }, (data, url) => {
                commit("SAVE_ORDERS_ERROR", data);
                catcher(data, url);
            }
        )
    },
    createOrders: ({dispatch, commit, getters}, {data, finalizer=()=>{}, catcher=()=>{}}) => {
        let url = representative.REPRESENTATIVE.ORDERS.CREATE()
        executeRequest("Orders", sendPostFileRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
    },
    changeOrders: ({dispatch, commit, getters}, {data, finalizer,catcher}) => {
        let url = representative.REPRESENTATIVE.ORDERS.UPDATE(data.get("id"))
        executeRequest("Orders", sendPutFileRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
    },
    deleteOrders: ({dispatch, commit, getters}, {id, finalizer, catcher}) => {
        let url = representative.REPRESENTATIVE.ORDERS.DELETE(id)
        executeRequest("Orders", sendDeleteRequest, {url, finalizer, catcher}, {dispatch, commit, getters});
    },
    copyOrders: ({dispatch, commit, getters}, {id, finalizer, catcher}) => {
        let url = representative.REPRESENTATIVE.ORDERS.COPY(id)
        executeRequest("Orders", sendGetRequest, {url, finalizer, catcher}, {dispatch, commit, getters});
    },
    formalizeOrders: ({dispatch, commit, getters}, {id, data, finalizer, catcher}) => {
        let url = representative.REPRESENTATIVE.ORDERS.FORM(id)
        executeRequest("Orders", sendPutRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
    },
    withdrawOrders: ({dispatch, commit, getters}, {id, data, finalizer, catcher}) => {
        let url = representative.REPRESENTATIVE.ORDERS.WITHDRAW(id)
        executeRequest("Orders", sendPutRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
    },
    annulOrders: ({dispatch, commit, getters}, {id, data, finalizer, catcher}) => {
        let url = representative.REPRESENTATIVE.ORDERS.ANNUL(id)
        executeRequest("Orders", sendPutRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
    },
    loadOrdersLimits: ({commit}, {url, finalizer=()=>{}, catcher=()=>{}}) => {
        if (!url) url = representative.REPRESENTATIVE.ORDERS.LIMITS()
        sendGetRequest(
            url, (data, url) => {
              commit("SET_ORDERS_LIMITS", data);
              finalizer(data, url);
            }, (data, url) => {
              commit("SAVE_ORDERS_ERROR", data);
              catcher(data, url);
            }
        )
    },
    loadUserOrganization: ({commit}, {url, finalizer=()=>{}, catcher=()=>{}}) => {
        if (!url) url = representative.REPRESENTATIVE.ORDERS.USER_ORGANIZATION()
        sendGetRequest(
            url, (data, url) => {
              commit("SET_USER_ORGANIZATION", data);
              finalizer(data, url);
            }, (data, url) => {
              commit("SAVE_ORDERS_ERROR", data);
              catcher(data, url);
            }
        )
    }
}

const mutations = {
    SET_ORDERS_LIST: (state, orders) => {
        state.orders.items = orders
    },
    SET_ORDERS_COUNT: (state, value) => {
        state.orders.count = value
    },
    SET_NOT_FORMED_ORDERS: (state, value) => {
        state.orders.not_formed_orders = value
    },
    SET_ORDERS_CURRENT_URL: (state, value) => {
        state.orders.currentUrl = value
    },
    SET_ORDERS_LOADING: (state) => {
        state.orders.loading = true
    },
    SET_ORDERS_LOADING_END: (state) => {
        state.orders.loading = false
    },
    SET_ORDERS_DETAIL: (state, value) => {
        state.orders.detail = value
    },
    SAVE_ORDERS_ERROR: (state, error) => {
        state.orders.error = error
    },
    SET_ORDERS_LIMITS: (state, limits) => {
        state.orders.limits = limits
    },
    SET_USER_ORGANIZATION: (state, value) => {
        state.orders.organization = value
    }
}


export default {
    namespaced: false,
    state,
    mutations,
    actions,
    getters
}
